import React from 'react'
import Navbar from '../inc/Navbar'
import About from './About'

function Aboutus() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
        <About/>
        <br/>
    </div>
  )
}

export default Aboutus